module.exports = __webpack_public_path__ + "img/Streuselberg.3823b7b3.jpg";